import React from 'react'
import { Stack } from 'react-bootstrap'
import { Link, useLocation } from 'react-router-dom'

export default function AdminButtonNavigator(props) {
    const location = useLocation();

  return (
    <Stack direction='vertical' gap={2}>
        <h2>Administator Navigation</h2>
        {   location.pathname === '/' ? 
            <Link role="button" aria-pressed="true" className='btn btn-outline-success active' to="/">Home</Link> :
            <Link role="button" className='btn btn-outline-success' to="/">Home</Link> 
        }
        {   location.pathname.startsWith('/reservation') ? 
            <Link role="button" aria-pressed="true" className='btn btn-outline-danger active' to="/reservation/any">Reservations</Link> :
            <Link role="button" className='btn btn-outline-danger' to="/reservation/any">Reservations</Link> 
        }
        {   location.pathname.startsWith("/tours") ? 
            <Link role="button" aria-pressed="true" className='btn btn-outline-warning active' to="/tours/management">Tour Management</Link> :
            <Link role="button" className='btn btn-outline-warning' to="/tours/management">Tour Management</Link> 
        }
        {   location.pathname.startsWith("/drivers") ? 
            <Link role="button" aria-pressed="true" className='btn btn-outline-danger active' to="/drivers/management">Driver Management</Link> :
            <Link role="button" className='btn btn-outline-danger' to="/drivers/management">Driver Management</Link> 
        }
        {   location.pathname.startsWith("/locations") ? 
            <Link role="button" aria-pressed="true" className='btn btn-outline-success active' to="/locations/management">Location Management</Link> :
            <Link role="button" className='btn btn-outline-success' to="/locations/management">Location Management</Link> 
        }
        {   location.pathname.startsWith("/guides") ? 
            <Link role="button" aria-pressed="true" className='btn btn-outline-warning active' to="/guides/management">Guide Management</Link> :
            <Link role="button" className='btn btn-outline-warning' to="/guides/management">Guide Management</Link> 
        }
        {   location.pathname.startsWith("/buses") ? 
            <Link role="button" aria-pressed="true" className='btn btn-outline-danger active' to="/buses/management">Bus Management</Link> :
            <Link role="button" className='btn btn-outline-danger' to="/buses/management">Bus Management</Link> 
        }
        {   location.pathname.startsWith("/rental") ? 
            <Link role="button" aria-pressed="true" className='btn btn-outline-success active' to="/rental/management">Rental Management</Link> :
            <Link role="button" className='btn btn-outline-success' to="/rental/management">Rental Management</Link> 
        }
        {/*{   location.pathname.startsWith("/shuttle") ? 
            <Link role="button" aria-pressed="true" className='btn btn-outline-warning active' to="/shuttle">Shuttle Management</Link> :
            <Link role="button" className='btn btn-outline-warning' to="/shuttle">Shuttle Management</Link> 
        }
        {   location.pathname.startsWith("/chauffeuring") ? 
            <Link role="button" aria-pressed="true" className='btn btn-outline-warning active' to="/chauffeuring">Chauffeur Management</Link> :
            <Link role="button" className='btn btn-outline-warning' to="/chauffeuring">Chauffeur Management</Link> 
        }
        {   location.pathname.startsWith("/arrangements") ? 
            <Link role="button" aria-pressed="true" className='btn btn-outline-warning active' to="/arrangements">Arrangements Management</Link> :
            <Link role="button" className='btn btn-outline-warning' to="/arrangements">Arrangements Management</Link> 
        }
        {   location.pathname.startsWith("/events") ? 
            <Link role="button" aria-pressed="true" className='btn btn-outline-danger active' to="/events">Events Management</Link> :
            <Link role="button" className='btn btn-outline-danger' to="/events">Events Management</Link> 
        }
        {   location.pathname.startsWith("/shopping") ? 
            <Link role="button" aria-pressed="true" className='btn btn-outline-danger active' to="/shopping">Shopping Management</Link> :
            <Link role="button" className='btn btn-outline-danger' to="/shopping">Shopping Management</Link> 
        }
        {   location.pathname.startsWith("/delivery") ? 
            <Link role="button" aria-pressed="true" className='btn btn-outline-danger active' to="/delivery">Delivery Management</Link> :
            <Link role="button" className='btn btn-outline-danger' to="/delivery">Delivery Management</Link> 
        }*/}
    </Stack>
  )
}
